// Ported from the hand-built pages/HowToOrderPage.js.
import { LEGACY, IMG } from 'styles/theme';
import DELIVERY from '../fragments/delivery';

// Subscriptions are still sold on the legacy Squarespace site.
const SUBSCRIBE = `${LEGACY}/prepared-meal-subscription`;

const page = {
  title: 'How To Order',
  hero: {
    // The citrus row in banner.webp slopes ~3 degrees, so the fruit centres
    // aren't level and the crop can't be centred vertically without the row
    // running downhill. Waiting on a rotated export; set `focus` here (a
    // backgroundPosition) once it lands.
    title: 'How To Order',
    image: IMG.htoBanner,
  },
  blocks: [
    {
      type: 'split',
      image: IMG.htoStep1,
      imageAlt: 'Prepared Square Fare meals arranged in glass containers',
      // Pinned square on all three steps, so copy length doesn't resize the photos.
      imageAspect: '1 / 1',
      imageSide: 'left',
      groups: [
        {
          heading: '1. Pick Your Plan',
          paragraphs: [
            [
              'Pick a ', { label: 'subscription', href: SUBSCRIBE },
              ' or order ', { label: 'à la carte', to: '/this-weeks-menu' },
              " from this week's menu. Whatever you choose, we adapt your food to fit your needs. ",
              "You're always welcome to request changes and substitutions — just submit your request ",
              'via email before Saturdays at 12pm.',
            ],
          ],
        },
      ],
      cta: { label: 'Get Started', href: SUBSCRIBE },
    },
    {
      type: 'split',
      tone: 'warm',
      image: IMG.htoStep2,
      imageAlt: 'Colourful salad bowls made up of fresh vegetables and grains',
      imageAspect: '1 / 1',
      groups: [
        {
          heading: '2. Take Our Quiz',
          paragraphs: [
            [
              'Take our ', { label: '3-minute lifestyle quiz', to: '/quiz' },
              '! The information is used to tailor our menu to fit your specific needs. Our team of ',
              'nutritionists analyzes your results to determine the nutritional requirements you need ',
              'to reach your health goals.',
            ],
          ],
        },
      ],
      // Starts the quiz itself, not a subscription.
      cta: { label: 'Get Started', to: '/quiz' },
    },
    {
      type: 'split',
      image: IMG.htoStep3,
      imageAlt: 'A Square Fare meal being handed over at a customer’s door',
      imageAspect: '1 / 1',
      imageSide: 'left',
      groups: [
        {
          heading: '3. Feel Good',
          paragraphs: [
            "We do the research and cooking so you don't have to! All meals come ready to eat — just "
            + 'pop in the microwave if needed and enjoy. '
            + `${DELIVERY.line} (unless otherwise requested.)`,
          ],
        },
      ],
      cta: { label: 'Get Started', href: SUBSCRIBE },
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
